import { Pipe, PipeTransform, inject } from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';

@Pipe({
    name: 'safeHTML',
    standalone: false
})
export class SafeHTMLPipe implements PipeTransform {
    private sanitizer = inject(DomSanitizer);


    transform(value: string): SafeHtml {
        return this.sanitizer.bypassSecurityTrustHtml(value);
    }

}
